export const checkIsFarmEnvironment = () => {
  try {
    const policyTypes = JSON.parse(import.meta.env.VITE_AVAILABLE_POLICY_TYPES);
    return policyTypes.F === true;
  } catch {
    return false;
  }
};
